/** 
 * @type {import("./defs").StoreInvestorContract} 
 */ 
 const store = { 
 } 
 /** 
 * @returns {import("./defs").StoreInvestorContract} 
 */ 
 export default function () { 
 return JSON.parse(JSON.stringify(store)); 
 }


// WEBPACK FOOTER //
// ./resources/js/storers/StoreInvestorContract.js